
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/safe-apps",
      function () {
        return require("private-next-pages/settings/safe-apps/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/safe-apps"])
      });
    }
  